import { useMemo } from 'react';

import { usePendingSelectionCommit } from '~/components/v2/components/private-selection-bar/hooks/usePendingSelectionCommit';
import { usePrivateWorkspaceAgentPanelComposerPills } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { buildWorkspaceAgentComposerScopeChip } from '~/components/v2/components/workspace/workspace-agent-panel/utils/buildWorkspaceAgentComposerScopeChip';
import { useFrozenWhile } from '~/hooks/useFrozenWhile';

/** Scope chip for the composer overlay — frozen during replace-click mousedown like the scope bar. */
export const usePrivateWorkspaceAgentComposerScopeChip = () => {
  const { scopePills } = usePrivateWorkspaceAgentPanelComposerPills();
  const { isPendingCommit } = usePendingSelectionCommit();
  const { value: displayScopePills } = useFrozenWhile(scopePills, isPendingCommit);

  const scopeChip = useMemo(() => buildWorkspaceAgentComposerScopeChip(displayScopePills), [displayScopePills]);

  return { scopeChip };
};
